import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import root from "./root";
import layout from "./modules/layout";
import project from "./modules/project";
import event from "./modules/event";
import level from "./modules/level";
import booking from "./modules/booking";
import datasource from "./modules/datasource";
import user from "./modules/user";
import bookingRequest from "./modules/bookingRequest";

export default new Vuex.Store({
  state: root.state,
  mutations: root.mutations,
  actions: root.actions,
  getters: root.getters,
  modules: {
    layout,
    project,
    event,
    level,
    booking,
    datasource,
    user,
    bookingRequest
  }
});